<template>
  <van-dialog :value="value" @input="$emit('input', $event)" class="buy-dialog" :showConfirmButton="false"
    :close-on-click-overlay="true">
    <div class="title" slot="title">{{ title }}</div>
    <div class="contentText">
      <div>{{ contentText }}</div>
    </div>
    <div>
      <div v-if="isApp && appTip" class="footer iostip">
        <div>{{ appTip }}</div>
      </div>
      <div v-else-if="isIOSWxMini" class="footer iostip">
        <div>由于相关规范，iOS功能暂不可用</div>
      </div>

      <div v-else class="footer">
        <div class="btn cancelBtn" @click="cancelClick">{{ cancelText }}</div>
        <div class="btn confirmBtn" @click="confirmClick">{{ confirmText }}</div>
      </div>
    </div>

  </van-dialog>
</template>
<script>
import { judgeDeviceType } from "@/utils/device";
export default {
  props: {
    title: {
      type: String,
      default: '温馨提示'
    },
    value: {
      type: Boolean,
      default: false,
    },
    contentText: {
      type: String,
      default: '你还不是会员，该服务仅开放给会员使用，成为会员后可以购买字数使用。'
    },
    appTip: {
      type: String,
      default: ''
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    confirmText: {
      type: String,
      default: '成为会员'
    },

  },
  computed: {


  },
  data() {
    return {
      isIOSWxMini: judgeDeviceType.isIOSWxMini,
      isApp: judgeDeviceType.isAPP
    }
  },
  methods: {
    cancelClick() {
      this.$emit('cancel')
    },
    confirmClick() {
      this.$emit('confirm')
    }
  },
}
</script>
<style lang="less" scoped>
.buy-dialog {
  box-sizing: border-box;
  width: 616px;
  background: #FFFFFF;
  border-radius: 30px;
  padding: 49px 56px 41px 56px;

  /deep/ .van-dialog__header {
    padding: 0px;
    line-height: normal;
  }

  .title {
    font-size: 30px;
    font-family: HarmonyOS_Sans_SC_Medium;
    color: #333333;
    line-height: 30px;
    height: 30px;
    margin-bottom: 24px;
  }

  .contentText {
    font-size: 26px;
    font-family: HarmonyOS_Sans_SC;
    color: #333333;
    line-height: 36px;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .btn {
      width: 224px;
      height: 76px;
      background: #EBEBEB;
      border-radius: 38px;
    }

    font-size: 30px;
    font-family: HarmonyOS_Sans_SC;
    color: #333333;
    line-height: 76px;
    box-sizing: border-box;
    text-align: center;
    margin-top: 66px;
    margin-bottom: 0px;
  }

  .iostip {
    font-size: 30px;
    font-family: HarmonyOS_Sans_SC;
    color: #E02020;
    line-height: 42px;
    text-align: center;

    &>div {
      flex: 1;
    }
  }

  .confirmBtn {
    background: #F0BF89 !important;
    color: #8F4900;
  }
  .van-dialog__footer {
    display: none;
  }

}
</style>